import React, { useMemo } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

export const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        y: {
            beginAtZero: true,
            grid: { display: false },
        },
        x: {
            title: { display: true, text: 'Months (FY)' },
            ticks: { autoSkip: false, maxRotation: 45, minRotation: 30 },
            grid: { display: false },
        },
    },
};

// Fiscal year months: April → March
const fiscalMonths = [
    'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep',
    'Oct', 'Nov', 'Dec',
    'Jan', 'Feb', 'Mar'
];

export function Sparesline({ complaintFiscalYearWiseStateData = [] }) {
    // console.log("From Component", complaintFiscalYearWiseStateData);

    const chartData = useMemo(() => {
        // Map data to month index (0-based)
        const monthDataMap = {};
        complaintFiscalYearWiseStateData.forEach(item => {
            const monthIndex = parseInt(item.key, 10) - 1; // "01" -> 0
            if (monthIndex >= 0 && monthIndex < 12) {
                monthDataMap[monthIndex] = item.doc_count;
            }
        });

        // Fill values for fiscal year order: Apr (3) → Mar (2)
        const fiscalValues = [
            monthDataMap[3] || 0,  // Apr
            monthDataMap[4] || 0,  // May
            monthDataMap[5] || 0,  // Jun
            monthDataMap[6] || 0,  // Jul
            monthDataMap[7] || 0,  // Aug
            monthDataMap[8] || 0,  // Sep
            monthDataMap[9] || 0,  // Oct
            monthDataMap[10] || 0, // Nov
            monthDataMap[11] || 0, // Dec
            monthDataMap[0] || 0,  // Jan
            monthDataMap[1] || 0,  // Feb
            monthDataMap[2] || 0,  // Mar
        ];

        return {
            labels: fiscalMonths,
            datasets: [
                {
                    label: 'Complaints',
                    data: fiscalValues,
                    borderColor: '#5DADE2',
                    backgroundColor: 'rgba(93, 173, 226, 0.4)',
                    tension: 0.3,
                    fill: true,
                },
            ],
        };
    }, [complaintFiscalYearWiseStateData]);

    return (
        <div style={{ height: '290px' }}>
            <Line options={options} data={chartData} />
        </div>
    );
}
